import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { posList, posUpdate } from "../../services/api";
import { API_STATUS } from "../../utils/constants";
import EncryptDecrypt from './../../utils/encrypt&decrypt';
import { secretKey } from "../../services/config";
import alertmessage from './../../utils/alert';
const namespace = "pos";

const initialState = {
    loading: "initial",
    addloading: "initial",
    updateloading: "initial",
    deleteloading: "initial",
    errorMessage: null,
    posDatas: null,
    posCount: 0
};

export const posData = createAsyncThunk(
    `${namespace}/posData`,
    async ({ query = "", page = 0, limit = 0, sortby = "", order = "" }, { rejectWithValue, dispatch }) => {
        try {
            console.log("interdata");
            //let payload = EncryptDecrypt.encryptdata(postData, secretKey)
            const data = await posList(query, page, limit, sortby, order);
            console.log("getCount--> ", data);
            return data;
        } catch (error) {
            console.log("getCount error--->", error);
            return rejectWithValue(error.response);
        }
    }
);
export const UpdatePos = createAsyncThunk(
    `${namespace}/UpdatePos`,
    async ({ postData, updateID }, { rejectWithValue, dispatch }) => {
        try {
            let payload = EncryptDecrypt.encryptdata(postData, secretKey)
            const data = await posUpdate({ payload: payload }, updateID);
            console.log("getCount--> ", data);
            return data;
        } catch (error) {
            console.log("getCount error--->", error);
            return rejectWithValue(error.response);
        }
    }
);


const posSlice = createSlice({
    name: namespace,
    initialState,
    reducers: {
        clearData: () => {
            return initialState;
        },
        clearPosLoadingDatas: (state) => {
            state.loading = "initial";
            state.addloading = "initial";
            state.updateloading = "initial";
            state.deleteloading = "initial";
        },
        clearPosAddLoading: (state) => {
            state.addloading = "initial";
        },
        clearPosUpdateLoading: (state) => {
            state.updateloading = "initial";
        },
        clearPosDeleteLoading: (state) => {
            state.deleteloading = "initial";
        },
        clearErrormsg: (state) => {
            state.errorMessage = null;
        }
    },
    extraReducers: {
        [posData.pending](state) {
            state.loading = API_STATUS.PENDING;
        },
        [posData.fulfilled](state, { payload }) {
            state.loading = API_STATUS.FULFILLED;
            // state.posCount = payload?.data?.count;
            // state.posDatas = JSON.parse(EncryptDecrypt.decryptdata(payload?.data?.datas, secretKey));
            let payloaddatas = JSON.parse(EncryptDecrypt.decryptdata(payload?.data?.datas, secretKey));
            console.log(payloaddatas?.response, "payload")
            state.posCount = payloaddatas?.count;
            state.posDatas = payloaddatas?.data;
        },
        [posData.rejected](state, action) {
            state.loading = API_STATUS.REJECTED;
            if (action?.payload?.data?.auth === "deleted") {
                alertmessage.sweetalert(action?.payload?.data?.message);
            }
            state.errorMessage = action?.payload?.data;
        },
        [UpdatePos.pending](state) {
            state.updateloading = API_STATUS.PENDING;
        },
        [UpdatePos.fulfilled](state, { payload }) {
            state.updateloading = API_STATUS.FULFILLED;
        },
        [UpdatePos.rejected](state, action) {
            state.updateloading = API_STATUS.REJECTED;
            state.errorMessage = action?.payload?.data;
        },
    },
});

export const { clearData, clearLoadingDatas, clearPosAddLoading, clearPosUpdateLoading, clearPosDeleteLoading, clearErrormsg } = posSlice.actions;

export const posSelector = (state) => state.pos;

export default posSlice.reducer;
